import React from 'react';
import ArticlesOverview from '../articles/articlesOverview';
import { NewsListerWrapper } from './newsLister.styles';

const NewsLister = () => {
	return (
		<NewsListerWrapper>
			<ArticlesOverview />;
		</NewsListerWrapper>
	);
};

export default NewsLister;
